import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm">
              关于郝海东最值得阅读的深度内容
            </p>
          </div>
          <Link
            to="/category/goals"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 rounded-full text-sm font-medium hover:bg-secondary-200 transition-colors duration-200 whitespace-nowrap"
          >
            <span>查看全部文章</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              slug={article.slug}
              title={article.title}
              excerpt={article.excerpt}
              image={article.image}
              date={article.date}
              readTime={article.readTime}
              category={article.category}
              categoryName={getCategoryName(article.category)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}